import { uniqBy } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import AppStore from 'store/AppStore'
import ProgressCard from '../../../../../components/card/ProgressCard'
import Table from '../../../../../components/datatable/Table'
import Input from '../../../../../components/forms/Input'
import NumberField from '../../../../../components/forms/NumberField'
import RadioButtons from '../../../../../components/forms/RadioButtons'
import DtoJob from '../../../../../import/dto/DtoJob'
import PiezometryAction from '../../../../../piezometry/actions/PiezometryAction'
import DtoParametrageDataType from '../../../../../piezometry/dto/DtoParametrageDataType'
import DtoPiezometerLight from '../../../../../piezometry/dto/DtoPiezometerLight'
import { nbPerPageLabelShort } from '../../../../../referencial/constants/ReferencialConstants'
import { getMeasureCoteList } from '../../../../../utils/JobUtils'
import { hasValue } from '../../../../../utils/NumberUtil'
import { arrayOf, instanceOf } from '../../../../../utils/StoreUtils'
import DtoPiezometer from '../../../../dto/DtoPiezometer'

class MISManualPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataLoaded: true,
            progress: 0,
        }
    }

    componentDidMount() {
        AppStore.dispatch(PiezometryAction.fetchPiezometryDataTypes())
        if (!this.props.job.parameters.parameters.length) {
            this.addParameterNew({ stationCode: this.props.piezometer.code, stationId: this.props.piezometer.id, data: this.props.selectedDataType === -1 ? [{ dataType: -1, channels: '0001' }] : [] })
            setTimeout(() => this.onChangeFilters({
                dateFormat: 'AAAAMMJJ',
            }), 500)
        }
    }

    onChangeParametersNew = (currentParameter, index, changes) => {
        const jobParameters = {
            ...this.props.job.parameters,
            parameters: Object.assign([], this.props.job.parameters.parameters, {
                [index]: JSON.stringify({ ...currentParameter, ...changes }),
            }),
        }
        this.props.onChangeJob({ parameters: jobParameters })
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    onChangeColumns = (parameter, index, dataType, channels) => {
        const actualData = parameter.data || []
        const newData = (() => {
            if (!hasValue(channels)) {
                return actualData.filter(d => d.dataType !== dataType)
            }
            return uniqBy([ { dataType, channels }, ...actualData], 'dataType')
        })()
        this.onChangeParametersNew(parameter, index, { data: newData })
    }

    findData = (parameter, dataType) => {
        const found = (parameter.data || []).find(d => d.dataType === dataType)
        return found ? found.channels : null
    }

    getFilters = () => {
        const newFilters = this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}
        return { measureCote: 2, ...newFilters }
    }

    getParametersNew = () => this.props.job.parameters.parameters.length ? this.props.job.parameters.parameters.map(p => JSON.parse(p)) : []

    getDataTypes = () => [{ id: this.props.selectedDataType, label: i18n.channel }]

    onDeleteParameter = (index) => {
        if (this.props.isEditMode) {
            const jobParameters = {
                ...this.props.job.parameters,
                parameters: this.props.job.parameters.parameters.filter((_, i) => i !== index),
            }
            this.props.onChangeJob({ parameters: jobParameters })
        }
    }

    onDuplicateParameter = (index) => {
        if (this.props.isEditMode) {
            const jobParameters = {
                ...this.props.job.parameters,
                parameters: [ ...this.props.job.parameters.parameters, this.props.job.parameters.parameters[index] ],
            }
            this.props.onChangeJob({ parameters: jobParameters })
        }
    }

    getParametersData = (filters, parameters) => {
        const disabled = { disabled: !this.props.isEditMode }
        return parameters.map((p, index) => {
            const columnFields = this.getDataTypes().reduce((acc, val) => ({
                ...acc,
                [`data${val.id}`]: <Input value={ this.findData(p, val.id) } onChange={ v => this.onChangeColumns(p, index, val.id, v) } {...disabled }/>,
            }), {})
            return {
                coeff: <NumberField value={ p.factor } onChange={ v => this.onChangeParametersNew(p, index, { factor: v }) } floatValue {...disabled }/>,
                offset: <NumberField value={ p.offset } onChange={ v => this.onChangeParametersNew(p, index, { offset: v }) } floatValue {...disabled }/>,
                ...columnFields,
            }
        })
    }

    addParameterNew = (initial = {}) => {
        if (this.props.isEditMode) {
            const jobParameters = {
                ...this.props.job.parameters,
                parameters: [ ...this.props.job.parameters.parameters, JSON.stringify(initial)],
            }
            this.props.onChangeJob({ parameters: jobParameters })
        }
    }

    render() {
        if (this.state.dataLoaded) {
            const disabled = !this.props.isEditMode
            const filters = this.getFilters()
            const parameters = this.getParametersData(filters, this.getParametersNew())
            const baseHeaders = ['coeff', 'offset']
            const columnHeaders = this.getDataTypes().map(type => `data${type.id}`)
            const customHeaders = this.getDataTypes().reduce((acc, val) => ({ ...acc, [`data${val.id}`]: val.label }), {})
            return (
                <div>
                    <div className='row no-margin valign-wrapper padding-top-1'>
                        <Input col={ 3 } title={ i18n.formatDate } value={ filters.dateFormat } onChange={ v => this.onChangeFilters({ dateFormat: v }) } disabled={ disabled }/>
                        <RadioButtons col={ 3 } elements={ getMeasureCoteList() } selected={ filters.measureCote } onChange={ v => this.onChangeFilters({ measureCote: v }) } title={ i18n.ratingExpression } disabled={ disabled }/>
                        <NumberField col={ 3 } title={ i18n.excludedValue } value={ filters.excludedValue } onChange={ v => this.onChangeFilters({ excludedValue: v }) } disabled={ disabled } floatValue />
                        <div className='col s3'/>
                    </div>
                    {
                        (parameters.length > 0) && (
                            <div className='job-parameter-table'>
                                <Table
                                    showTitle={ false }
                                    data={ parameters }
                                    nbPerPageLabel={ nbPerPageLabelShort }
                                    type={ { headers: [ ...baseHeaders, ...columnHeaders ] } }
                                    sortable
                                    condensed
                                    paging
                                    customHeaders={ customHeaders }
                                />
                            </div>
                        )
                    }
                </div>
            )
        }
        return <ProgressCard progress={ this.state.progress }/>
    }
}

MISManualPanel.propTypes = {
    job: PropTypes.instanceOf(DtoJob).isRequired,
    onChangeJob: PropTypes.func.isRequired,
    piezometryDataTypes: arrayOf(DtoParametrageDataType),
    piezometers: arrayOf(DtoPiezometerLight),
    isEditMode: PropTypes.bool,
    piezometer: instanceOf(DtoPiezometer),
    selectedDataType: PropTypes.number,
}

const mapStateToProps = store => ({
    piezometryDataTypes: store.PiezometryReducer.piezometryDataTypes,
    piezometers: store.PiezometryReducer.piezometersLight,
    piezometer: store.StationReducer.piezometer,
})

export default connect(mapStateToProps)(MISManualPanel)